export default __webpack_public_path__ + "static/media/facebook.8a45ab1f.svg";